<template>
  <q-card
    class="q-pa-md column"
    style="height: 70vh;width: 100vw;max-width: 400px"
  >
    <q-card-section class="col-grow column">
      <header class="q-mb-md">
        <span class="text-bold q-mb-md" style="font-size: 1.4rem">
          绑定用户组
        </span>
      </header>
      <q-scroll-area class="column col-grow">
        <q-list>
          <q-item
            clickable
            :disable="bandGroup && bandGroup.id === group.id"
            dense
            style="height: 36px"
            class="q-mb-sm row items-center justify-between"
            v-for="group in userGroupList"
            :key="group.id"
            @click="checked = group.id"
            :class="{
              'bind-user-group-item-active': checked === group.id,
              'bind-user-group-item-disable':
                bandGroup && bandGroup.id === group.id,
            }"
          >
            <span>
              {{ group.name }}
              <span v-if="bandGroup && bandGroup.id === group.id">
                （当前已绑定）
              </span>
            </span>

            <q-badge v-if="group.sample_group">
              {{ group.sample_group.name }}
            </q-badge>
            <q-badge v-else color="green">
              未绑定样本组
            </q-badge>
          </q-item>
        </q-list>
      </q-scroll-area>
    </q-card-section>

    <q-card-actions class="row justify-end">
      <q-btn outline color="primary" @click="$emit('cancel')">取消</q-btn>
      <q-btn
        flat
        class="text-white bg-primary"
        :disable="!checked"
        @click="doBind"
      >
        确认
      </q-btn>
    </q-card-actions>
  </q-card>
</template>

<script>
import { getGroupList } from "@/api/endpoints/group/getGroupList";
import { bindUserGroupToSampleGroup } from "@/api/endpoints/sample-group/bindUserGroupToSampleGroup";
export default {
  props: {
    groupId: {
      type: String,
    },

    /**
     * 已绑定的目标分组对象
     */
    bandGroup: {
      type: Object,
    },
  },

  data() {
    return {
      userGroupList: [],
      checked: null,
    };
  },

  mounted() {
    this.fetchUserGroupList();
  },

  methods: {
    /**
     * 获取用户分组列表
     */
    async fetchUserGroupList() {
      try {
        const res = await getGroupList();
        if (res.status || res.error) throw Error(res.detail || res.message);
        this.userGroupList = res;
      } catch (err) {
        this.$q.notify({
          type: "danger",
          message: err.toString(),
        });
      }
    },

    async doBind() {
      // groupId: 当前样本组 的 id
      // checked: 选中的用户组的 ID
      const { groupId, checked } = this;
      try {
        const res = await bindUserGroupToSampleGroup(checked, groupId);
        if (res.status || res.error) throw Error(res.detail || res.message);
        this.$q.notify({ type: "success", message: "已绑定" });
        this.$emit("updated");
      } catch (err) {
        this.$q.notify({ type: "danger", message: err.toString() });
      }
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/quasar";

.bind-user-group-item-active {
  background-color: rgba($primary, 0.1);
  color: $primary !important;
  font-weight: bold;
}
</style>
